import CarPartGroupItem from './CarPartGroupItem';

export default CarPartGroupItem;
